// extracted by mini-css-extract-plugin
export default {"heading-section":"card-id_heading-section__DXjk3"};